module.exports = __webpack_public_path__ + "static/media/eva.089c4f4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eva.jpg
// module id = 1372
// module chunks = 0